import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { RichText } from "prismic-reactjs";
import { withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import style from "./style";
import WorkItem from "../../components/WorkItem";
import CategoryTag from "../../components/CategoryTag";
import TitleSubtitle from "../../components/TitleSubtitle";
import CustomLink from "../../components/CustomLink";
import Link from "next/link";

const Projects = ({
  title,
  subtitle,
  categories,
  projects,
  viewAllCategory,
  classes,
  params,
}) => {
  const [nextPage, setNextPage] = useState(projects.next_page);
  const [results, setResults] = useState(projects.results);
  useEffect(() => {
    setResults(projects.results);
  }, [projects]);

  // useEffect(() => {
  //   fetch(`${nextPage}`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setResults(results.concat(data.results));
  //       setNextPage(data.next_page);
  //     });
  // }, [nextPage]);
  return (
    <Container maxWidth="lg" className={classes.Projects}>
      <TitleSubtitle title={title} subtitle={subtitle} />

      <Grid
        container
        spacing={2}
        direction="row"
        justify="center"
        alignItems="center"
        className="CategoryTagWrapper"
      >
        {viewAllCategory && (
          <Grid item>
            <CustomLink link={{ type: "page", uid: "projects" }}>
              <a style={{ textDecoration: "none" }}>
                <CategoryTag
                  selected={true}
                  CategoryTagIconSrc={"/viewAll.svg"}
                  CategoryTagIconAlt={"View All"}
                  CategoryTagTitle={"View All"}
                  showIcon
                />
              </a>
            </CustomLink>
          </Grid>
        )}
        {categories.results.map((category, index) => (
          <Grid item key={index}>
            <CustomLink link={category}>
              <CategoryTag
                selected={category.uid == params.uid}
                CategoryTagIconSrc={category.data.icon.url}
                CategoryTagIconAlt={category.data.icon.alt}
                CategoryTagTitle={RichText.asText(category.data.title)}
                showIcon
              />
            </CustomLink>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={4} direction="row" justify="center">
        {results &&
          results.map((project, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <WorkItem work={project} />
            </Grid>
          ))}
      </Grid>
    </Container>
  );
};

Projects.defaultProps = {
  viewAllCategory: false,
};

Projects.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  projects: PropTypes.objectOf(PropTypes.any).isRequired,
  categories: PropTypes.objectOf(PropTypes.any).isRequired,
  viewAllCategory: PropTypes.bool,
};

export default withStyles(style)(Projects);
